exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".final-proposal{color:#000;font-size:1rem}.ui-module-proposal{padding:20px;background-color:#fff;box-shadow:0 0 0 1px rgba(63,63,68,.05),0 1px 3px 0 rgba(63,63,68,.15);margin-bottom:20px}.ui-module-proposal-no-border{padding:20px;background-color:#fff;margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/proposal/proposal.scss
// module id = 6506
// module chunks = 0